import DatePicker from "react-datepicker"

import { ISelectTimeProps } from "./SelectTimeTypes"

import { Box, FormControl } from "@chakra-ui/react"
import { SelectTimeContainer } from "./StyledSelectTime"
import FormLabel from "components/UI/atoms/FormLabel"
import Icon from "components/UI/atoms/Icon"
import { LANGS } from "types/shared"

const SelecTime: React.FC<ISelectTimeProps> = ({
  name,
  selected,
  maxTime,
  minTime,
  isDisabled = false,
  label,
  inputStyles,
  timeIntervals = 15,
  onChange
}) => {
  const handleChange = (date: Date) => {
    onChange(name, date)
  }

  return (
    <FormControl>
      {label && <FormLabel id={name} text={label} />}
      <SelectTimeContainer className="datepicker-container" {...inputStyles}>
        <DatePicker
          name={name}
          selected={selected}
          onChange={handleChange}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={timeIntervals}
          dateFormat="HH:mm"
          timeFormat="HH:mm"
          minTime={minTime}
          maxTime={maxTime}
          disabled={isDisabled}
        />
        <Box className="datepicker-input-icon">
          <Icon name="dropdown" />
        </Box>
      </SelectTimeContainer>
    </FormControl>
  )
}

export default SelecTime
